import { useTaskSummary } from '../../Hooks/Features/employeeDashboard/useTaskSummary';
import { SkeletonContainer } from '../Loader/Loader';
const TasksSummary = () => {
    const { taskSummaryData, loader, issueCount, handleViewDetails } = useTaskSummary();
    return (
        <div title='Task Summary' className='employee-dash-height w100'>
            <div className='text-right text-primary c-pointer' onClick={handleViewDetails} >VIEW DETAILS</div>
            <div className='d-flex gap-1' style={{ height: "85%" }}>
                {loader ? <div className='w60'><SkeletonContainer /></div> :
                    <div className='w55'>
                        {taskSummaryData?.length === 0 ?
                            <div className='text-center d-flex flex-column flex-wrap justify-content-center align-items-center'>
                                <img src={"./assets/nodata.jpg"} alt='no data' width={80} height={80} />
                                <p className='text-center red'> Data Not Found</p>
                            </div> :
                            <div className='d-flex flex-wrap justify-content-center align-items-center column-gap-2 employee-dash-height'>
                                {taskSummaryData?.map((item, index) => (
                                    <div style={{ height: `${item?.size}px`, width: `${item?.size}px` }} title={`Issues: ${item?.issues}`} className='position-relative task-summary-bubble' key={index}>
                                        <span className=''>
                                            {item?.issue_percentage}%
                                        </span>
                                        <div className='w100' style={{ backgroundColor: item?.color }}></div>
                                    </div>
                                ))}
                            </div>
                        }
                    </div>
                }
                <div className='w45 d-flex flex-column justify-content-center align-items-start row-gap-2'>
                    <div className="d-flex gap-1 align-items-center justify-content-center">
                        <div className='task-summary-legend' style={{ backgroundColor: "grey" }} /> Backlog ({issueCount?.backlog})
                    </div>
                    <div className="d-flex gap-1 align-items-center justify-content-center">
                        <div className='task-summary-legend' style={{ backgroundColor: "blue" }} /> In Progress ({issueCount?.in_progress})
                    </div>
                    <div className="d-flex gap-1 align-items-center justify-content-center">
                        <div className='task-summary-legend' style={{ backgroundColor: "green" }} /> Done ({issueCount?.done})
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TasksSummary